import React, { Fragment } from "react";
import DrillDown from "../../d3Components/drillDownPie/drillDown";
import DataTable from "../../PortfolioDashboard/navigationPages/Datatable/DataTable";
import Spinner from "../../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import WithCard from "../../common/withCard";
import BuySellTable from "../../common/buySellTable";
import Helper from "../../pages/helper.current_buy_sell";

function CompareContent({
  yourDrilldown,
  yourChartOptions,
  iqcioDrilldown,
  iqcioChartOptions,
  yourTable,
  columns,
  optimizedTable,
  id,
  idIn,
  id2,
  idIn2,
  ErrorLoadingData,
  buySellTable,
  yourPortfolioApiCall,
  iqcioPortfolioApiCall,
}) {
  const buy_sell_heading = [
    "YOUR Portfolio",
    "Weight (%)",
    "IQCIO Portfolio",
    "Weight (%)",
    "Recommendation",
  ];
  const buy_sell_table_data = Helper.tableData(yourDrilldown, iqcioDrilldown);

  const Error = () => {
    return (
      <div>
        {/* {iqcioDrilldown.length ? (
          null && ErrorLoadingData === false
        ) : (
          <Spinner />
        )} */}
        {ErrorLoadingData == true ? (
          <div>Could not process request. Please try again later.</div>
        ) : (
          <Spinner />
        )}
      </div>
    );
  };
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <WithCard>
            <div className="universe__table-title">Your Portfolio</div>
            {yourDrilldown &&
            yourDrilldown.length === 0 &&
            yourPortfolioApiCall == false ? (
              <div>No data to display</div>
            ) : yourDrilldown && yourDrilldown.length === 0 ? (
              <Error />
            ) : null}
            {yourDrilldown && yourDrilldown.length ? (
              <DrillDown
                id={id}
                idInner={idIn}
                width={600}
                height={350}
                chartData={yourDrilldown}
                chartOptions={yourChartOptions}
              />
            ) : null}
          </WithCard>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <WithCard>
            <div className="universe__table-title">IQCIO optimized</div>
            {iqcioDrilldown &&
            iqcioDrilldown.length === 0 &&
            iqcioPortfolioApiCall == false ? (
              <div>No data to display</div>
            ) : iqcioDrilldown && iqcioDrilldown.length === 0 ? (
              <Error />
            ) : null}

            {iqcioDrilldown && iqcioDrilldown.length ? (
              <DrillDown
                id={id2}
                idInner={idIn2}
                width={600}
                height={350}
                chartData={iqcioDrilldown}
                chartOptions={iqcioChartOptions}
              />
            ) : null}
          </WithCard>
        </div>
      </div>
      <div className="row">
        {buySellTable === true ? (
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {buy_sell_table_data && buy_sell_table_data.length > 0 ? (
              <BuySellTable
                heading={buy_sell_heading}
                tableData={buy_sell_table_data}
              />
            ) : null}
          </div>
        ) : (
          <Fragment>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              {yourTable && yourTable.length ? (
                <DataTable
                  data={yourTable}
                  columns={columns}
                  paging={false}
                  searching={false}
                />
              ) : null}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              {optimizedTable && optimizedTable.length ? (
                <DataTable
                  data={optimizedTable}
                  columns={columns}
                  paging={false}
                  searching={false}
                />
              ) : null}
            </div>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
}

export default CompareContent;



// WEBPACK FOOTER //
// ./src/components/pages/compare/compareContent.jsx